import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const loadMarkAsReviewedAtom = createMutationAtomFactory(
  'customerPortal.loadMarkAsReviewed',
  (params: {
    loadId: string;
    receivingTicketNumber?: string;
    receivedTicketIssueDate?: string;
    millReceivedWeightPostDate?: string;
  }) => ({
    tradeLoadReview: {
      __args: {
        input: {
          id: params.loadId,
          receivingTicketNumber: params.receivingTicketNumber,
          receivedTicketIssueDate: params.receivedTicketIssueDate,
          millReceivedWeightPostDate: params.millReceivedWeightPostDate,
        },
      },
      id: true,
    },
  }),
);
